import './Line.css';
import Horse from './Horse';
import Player from './Player';

function Line({login, grade, state, animated, image}) {

  return (
    <div className="Line">
      <div className="progressBarContainer">
        <div className="progressBarBackground"></div>
        <div className="progressBarFill" style={{width: `${grade * 0.93}%`}}></div>
        <div className="progressBarGlow" style={{width: `${grade * 0.93}%`}}></div>
      </div>
      <Player position={grade * 0.90} login={login} image={image}/>
    </div>
  );
}

export default Line;
